import React from 'react';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Subtitle } from 'src/pages/scheduleSurgery/components/surgery/notifications/Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import { useTranslation } from 'react-i18next';

const NotImplantingUNiDRods = ({ onClose, label }) => {
    const { t } = useTranslation();

    return (
        <>
            <Popup
                title={label}
                onClose={onClose}
                margin
                popupContentPadding={'15px 20px 30px 20px'}
                iconWidth={'25px'}
                borderRadius={'6px'}
                id={'reportUsage-notImplantingUNiDRods-popup'}
            >
                <MyProfileDiv>
                    {label ==
                        t('procedure.unid.SurgeonChangedSurgicalPlan') && (
                        <>
                            <Subtitle>
                                {' '}
                                {t(
                                    'procedure.unid.ReasonsForImplantingUNiDRods.SurgeonChangedSurgicalPlanDescription'
                                )}
                            </Subtitle>

                            <Subtitle></Subtitle>
                        </>
                    )}
                    {label == t('procedure.unid.IssuewithLengthorContour') && (
                        <>
                            <Subtitle>
                                {' '}
                                {t(
                                    'procedure.unid.ReasonsForImplantingUNiDRods.IssuewithLengthorContour'
                                )}
                            </Subtitle>
                            <Subtitle>
                                <StyledSpan>
                                    {' '}
                                    {t(
                                        'procedure.unid.ReasonsForImplantingUNiDRods.Complaint'
                                    )}
                                    :{' '}
                                </StyledSpan>
                                {t(
                                    'procedure.unid.ReasonsForNotImplanting.complaint'
                                )}
                            </Subtitle>{' '}
                        </>
                    )}
                </MyProfileDiv>
            </Popup>
        </>
    );
};

export default NotImplantingUNiDRods;

export const MyProfileDiv = styled.div`
    width: 430px;
    max-height: 450px;
    overflow-y: scroll;
    ${media.mobileDevice`
         width:310px;
         max-height: 330px;         
         `}
`;

export const StyledSpan = styled.span`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-top: 10px;
`;
